module.exports = __webpack_public_path__ + "static/media/em-103.ce141225.png";